module.exports = __webpack_public_path__ + "static/img/pic5.b35912a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic5.png
// module id = 8prk
// module chunks = 0